import { qportalApi } from './qportal-api';
export const unavailablePortalCapabilities = {
    emailManagement: false,
    emailCockpit: false,
    adminEmailRecipients: false,
    freelancerInvoiceUpload: false,
    releaseId: 'legacy'
};
export const PortalCapabilitiesApi = {
    get: async (signal) => (await qportalApi.get('portal/capabilities', { signal })).data
};
